import {enGB, arSA, ru, es, de, fr, it, sq, tr, el} from 'date-fns/esm/locale'

import * as dateFns from 'date-fns'

const locales = {en: enGB, ar: arSA, ru, es, de, fr, it, sq, tr, el},
    defaultOptions = {
        format: 'yyyy-MM-dd',
    }

// TODO [P3] Use the plugin in all components instead direct import, need refactoring with widgets
export default defineNuxtPlugin(() => {
    const app = useNuxtApp()
    const locale = app.$i18n.locale.value
    const fallbackLocale = app.$i18n.fallbackLocale.value
    const dateObj = {
        ...dateFns,
        localeOptions: Object.keys(locales).reduce((localeOptions, locale) => {
            localeOptions[locale] = locales[locale].options
            return localeOptions
        }, {}),
    }

    function parsedDate(date) {
        if (dateFns.parseISO) {
            return typeof date !== 'string' ? date : dateFns.parseISO(date)
        }
        return date
    }

    if (dateFns.format) {
        dateObj.format = (date, format, options) => {
            return dateFns.format(parsedDate(date), format || defaultOptions.format, mergeOptions(options))
        }
    }

    if (dateFns.parse) {
        dateObj.parse = (dateString, formatString, backupDate, options) => {
            return dateFns.parse(dateString, formatString, backupDate, mergeOptions(options))
        }
    }

    const threeParams = [
        'differenceInCalendarWeeks',
        'formatDistance',
        'formatDistanceStrict',
        'formatRelative',
        'isMatch',
        'isSameWeek',
        'setDay',
        'setWeek',
        'setWeekYear',
    ].filter(value => Object.keys(dateFns).includes(value))

    for (const fn of threeParams) {
        dateObj[fn] = (param1, param2, options) => {
            return dateFns[fn](param1, param2, mergeOptions(options))
        }
    }

    const twoParams = [
        'eachWeekOfInterval',
        'endOfWeek',
        'formatDistanceToNow',
        'formatDistanceToNowStrict',
        'formatDuration',
        'getWeek',
        'getWeekOfMonth',
        'getWeeksInMonth',
        'getWeekYear',
        'isThisWeek',
        'lastDayOfWeek',
        'startOfWeek',
        'startOfWeekYear',
    ].filter(value => Object.keys(dateFns).includes(value))

    for (const fn of twoParams) {
        dateObj[fn] = (param, options) => {
            return dateFns[fn](param, mergeOptions(options))
        }
    }

    function mergeOptions(options) {
        options = {locale, fallbackLocale, ...options}
        if (options && typeof options.locale === 'string') {
            if (locales[options.locale]) {
                options.locale = locales[options.locale]
            } else if (options.fallbackLocale && locales[options.fallbackLocale]) {
                console.warn(
                    `[date-fns] locale '${options.locale}' not found, using fallback locale '${options.fallbackLocale}'`
                )
                options.locale = locales[options.fallbackLocale]
            } else {
                console.warn(`[date-fns] locale '${options.locale}' not found.`)
            }
        }
        return options
    }

    return {provide: {dateFns: dateObj}}
})
